import React, { useState, useEffect, useCallback } from "react";
import "./organization-settings-links.scss";

import { GSEmptyList, GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentOrganization,
  setSelectedOrganization,
  clearNotifications,
  selectOrganizationNotifications,
  selectOrganization,
  getOrgLinks,
  selectOrgLinks,
  createOrganizationLink,
  deleteOrganizationLink
} from "../../reducers/organizationSlice";
import {
  clearUtilityNotifications,
  setUploadedFile,
} from "../../reducers/utilitySlice";
import { getLinksForm } from "../../forms/SettingsForm";
import { useMatch } from "react-router-dom";
import {useNotificationAction} from "../../hooks/notificationHooks";

const OrganizationSettingsLinks = (props) => {
  const [isValid, setIsValid] = useState(false);
  const [newLink, setNewLink] = useState("")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const selectedOrganizationLinks = useSelector(selectOrgLinks)
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const matchEdit = useMatch("/:id/settings/events/links");
  let context = {};

  const clearLink = useCallback(() => setNewLink(""), []);
  useNotificationAction("created", orgNotifications, clearLink);

  const load = useCallback(() => {
    const { id } = matchEdit.params;
    if(id)
    {
      dispatch(getOrgLinks(id))
    }
  }, [dispatch, matchEdit.params]);

  useEffect(() => {
    load();
  }, [load]);

  const leftNavigation = () => {
    dispatch(selectOrganization(selectedOrganization.id))
    dispatch(setUploadedFile(""))
    dispatch(clearNotifications())
    dispatch(clearUtilityNotifications())
    navigate(-1);
  };

  context.updateOrganization = (value, property) => {
    setIsValid(true);
    let organization = { ...selectedOrganization };
    organization[property] = value;
    return dispatch(setSelectedOrganization(organization));
  };

  context.getNewLinkText = () => {
    return newLink
  }

  context.setNewLinkText = (link) => {
    setIsValid(true)
    setNewLink(link);
  }

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.addLink = () => {
    const link ={website: newLink, organization: selectedOrganization}
    dispatch(createOrganizationLink(link))
  }

  context.removeLink = (id) => {
    dispatch(deleteOrganizationLink(id))
  }

  context.linkSelected = (link) => {
    let l = link?.website?.startsWith?.("http") ? link?.website : `http://${link?.website}`
    window.open(l)
  }

  context.formIsValid = () => {
    return isValid;
  }

  context.getEmptyList = () => {
    return <GSEmptyList title="Organization Links" detail="Add links to the events list."/>
  }

  const getNavigation = () => {
    return {
      title: "Organization Links",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };
  const timeoutAction = () => {
    dispatch(clearNotifications());
  };
  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "View Events List Settings",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };
  const goToEventsList = () => {
    window.open(
      `${process.env.REACT_APP_GOLFSTATUS_EVENTS_BASE_URL}/organization/${selectedOrganization.id}`
    );
  };

  const getEventActions = () => {
    return [
      {
        title: "View Events List",
        actionClick: goToEventsList,
        rightIcon: faExternalLinkSquareAlt,
        type: "light-grey no-wrap mobile-icon",
      },
    ];
  };

  const getContent = () => {
    return <GSForm formTitle="Organization Links" formActions={getEventActions()} formSections={getLinksForm(context, selectedOrganizationLinks)} />;
  };

  return (
    <organization-settings-links>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
      />
    </organization-settings-links>
  );
};

export default OrganizationSettingsLinks;